import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";

const DOCTOLIB_URL =
  "https://www.doctolib.de/physiotherapie/garbsen/giusi-borghese";

const navItems = [
  { label: "Willkommen", href: "#willkommen" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Praxis", href: "#warum" },
  { label: "Einblicke", href: "#einblicke" },
  { label: "Termine", href: "#termine" },
  { label: "Kontakt", href: "#kontakt" },
];

const Navbar = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const isHome = pathname === "/";

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const handleAnchorClick = (e, href) => {
    setOpen(false);
    if (!isHome) return; // let router handle
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-md bg-[#FCF9F5]/85 border-b border-[#E8DFD8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-brand-link"
          className="flex flex-col leading-tight"
        >
          <span className="font-serif text-2xl md:text-[1.6rem] font-medium text-[#4A362E]">
            Borghese
          </span>
          <span className="text-[10px] md:text-[11px] tracking-[0.22em] uppercase text-[#B56553]">
            Physiotherapie
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {isHome &&
            navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleAnchorClick(e, item.href)}
                data-testid={`nav-link-${item.label.toLowerCase()}`}
                className="text-sm text-[#5C4E48] hover:text-[#B56553] transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
          {!isHome && (
            <Link
              to="/"
              data-testid="nav-back-home"
              className="text-sm text-[#5C4E48] hover:text-[#B56553] transition-colors"
            >
              Zurück zur Startseite
            </Link>
          )}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+4917621684344"
            data-testid="nav-phone-link"
            className="inline-flex items-center gap-2 text-sm text-[#4A362E] hover:text-[#B56553] transition-colors"
          >
            <Phone size={16} strokeWidth={1.75} className="text-[#B56553]" />
            0176 21684344
          </a>
          <a
            href={DOCTOLIB_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-doctolib-cta"
            className="inline-flex items-center rounded-full bg-[#B56553] hover:bg-[#9B5342] text-white text-sm font-medium px-5 py-2.5 transition-all duration-300 hover:-translate-y-0.5 shadow-[0_4px_20px_rgba(181,101,83,0.25)]"
          >
            Online buchen
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-full text-[#4A362E] hover:bg-[#F7F2EB]"
          aria-label="Menü"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="lg:hidden bg-[#FCF9F5] border-t border-[#E8DFD8] px-6 py-8 space-y-5"
        >
          {isHome &&
            navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleAnchorClick(e, item.href)}
                data-testid={`nav-mobile-link-${item.label.toLowerCase()}`}
                className="block text-lg font-serif text-[#4A362E]"
              >
                {item.label}
              </a>
            ))}
          {!isHome && (
            <Link
              to="/"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-back-home"
              className="block text-lg font-serif text-[#4A362E]"
            >
              Zurück zur Startseite
            </Link>
          )}
          <div className="pt-4 border-t border-[#E8DFD8] space-y-3">
            <a
              href="tel:+4917621684344"
              data-testid="nav-mobile-phone"
              className="flex items-center gap-2 text-[#4A362E]"
            >
              <Phone size={16} className="text-[#B56553]" /> 0176 21684344
            </a>
            <a
              href={DOCTOLIB_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-mobile-doctolib"
              className="inline-flex items-center rounded-full bg-[#B56553] text-white text-sm font-medium px-5 py-2.5"
            >
              Online buchen
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
